<template>
    <InformeCard id="venta_taquilla" name="venta_taquilla" collapsable="true" title="Venta taquilla">
        <div class="table-responsive">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>TIPO DE PRECIO</th>
                        <th>MÉTODO DE PAGO</th>
                        <th>CONCEPTO</th>
                        <th>TAQUILLERO</th>
                        <th>PRECIO</th>
                        <th>VENDIDAS</th>
                        <th>TOTAL</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(venta, index) in venta_taquilla">
                        <tr :key="index">
                            <td>{{ venta.description ?? venta.description_plaza }}</td>
                            <td>{{ venta.metodo_pago | formatear_metodo_pago_entrada }}</td>
                            <td>{{ venta.concepto }}</td>
                            <td v-if="venta.taquillero_nombre || venta.taquillero_apellidos">{{venta.taquillero_nombre != null || venta.taquillero_apellidos != null  ? venta.taquillero_nombre + ' ' + venta.taquillero_apellidos : '' }}</td>
                            <td v-else>{{venta.comprador_nombre != null || venta.comprador_apellidos != null  ? venta.comprador_nombre + ' ' + venta.comprador_apellidos : '' }}</td>
                            <td>{{ venta.price | formatear_precio }}</td>
                            <td>{{ venta.total }}</td>
                            <td>{{ venta.price * venta.total | formatear_precio }}</td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="5">TOTAL</td>
                        <td>{{ getTotalVendidas() }}</td>
                        <td>{{ getRecaudacionTotal() | formatear_precio }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id', 'informe'],
        computed: {
            venta_taquilla : function() {
                if(this.informe) {
                    var informe = this.informe.filter(function(v, i) {
                        return v.taquilla == 1 && (v.metodo_pago == 1 || v.metodo_pago == 2 || v.metodo_pago == 3 || v.metodo_pago == 7 || v.metodo_pago == 8 || v.metodo_pago == 9 || v.metodo_pago == 11);
                    });

                    return informe;
                }

                return null;
            },
        },
        methods: {
            getTotalVendidas() {
                var total = 0;
                for (var i = 0; i < this.venta_taquilla.length; i++) {
                    total = total + this.venta_taquilla[i].total;
                }

                this.$emit('totalVentas', total);

                return total;
            },
            getRecaudacionTotal() {
                var total = 0;
                for (var i = 0; i < this.venta_taquilla.length; i++) {
                    var rec = this.venta_taquilla[i].total * this.venta_taquilla[i].price
                    total = total + rec;
                }

                return total;
            }
        },
        components: {
            InformeCard,
        }
    }
</script>
